import loadingAttributePolyfill from 'loading-attribute-polyfill';
import { initClickTracking } from './click-tracking';

jQuery(function($)
{
    let $container = $('#content');
    let brandsSliderContainer = document.querySelector('#brands-slider');

    if (!$container.length)
    {
        return;
    }

    const processedSlides = [];

    if (brandsSliderContainer)
    {
        let brandsSlider = tns ({
            container: '.brands-slider',
            items: 1,
            slideBy: 1,
            lazyload: true,
            gutter: 9,
            nav: false,
            controlsContainer: '.tns-controls',
            speed: 400,
            mouseDrag: true,
            responsive: {
                300: {
                    items: 1
                },
                768: {
                    items: 3
                },
                1150: {
                    items: 5
                }
            }
        });

        brandsSlider.events.on('indexChanged', lazyLoadBrandsSlides);

        lazyLoadBrandsSlides();
    }

    function lazyLoadBrandsSlides()
    {
        let activeSlides = document.querySelectorAll('.tns-slide-active .tns-custom-lazy-img');

        activeSlides.forEach(slide =>
        {
            if (!processedSlides.includes(slide))
            {
                let slideSrcSet = slide.getAttribute('data-lazy-srcset');
                let slideSrc = slide.getAttribute('data-lazy-src');

                slide.setAttribute('srcset', slideSrcSet);
                slide.setAttribute('src', slideSrc);

                processedSlides.push(slide);
            }
        });
    }

    function reloadLazyLoadingPolyfill()
    {
        let lazyLoadedProductImages = $container[0].querySelectorAll('.loading-lazy');

        lazyLoadedProductImages.forEach((image) =>
        {
            loadingAttributePolyfill.prepareElement(image);
        });
    }

    function handleProductListReloaded()
    {
        reloadLazyLoadingPolyfill();
    }

    $container.on(orion.constants.EventProductListReloaded, handleProductListReloaded);

    initClickTracking();
});
